import { FC } from "react";

import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";
import type {
  ForumClassicTimelineImportResult,
  SegmentImportError,
} from "types/forum-classic-import";

type ForumClassicImportResultDialogProps = {
  open: boolean;
  onClose: () => void;
  result: ForumClassicTimelineImportResult | null;
  segmentErrors?: SegmentImportError[];
};

export const ForumClassicImportResultDialog: FC<ForumClassicImportResultDialogProps> = ({
  open,
  onClose,
  result,
  segmentErrors = result?.segment_errors ?? [],
}) => {
  const importedPageCount = result?.page_count ?? 0;
  const failedCount = segmentErrors.length;

  return (
    <Dialog
      dialogPanelClassName="w-[min(560px,100%)]"
      open={open}
      title={t("forum_classic_import.partial_title")}
      onClose={onClose}
    >
      <p className="body-s mt-3 text-black-tint-30">
        {t("forum_classic_import.partial_summary", {
          importedPageCount,
          count: failedCount,
        })}
      </p>
      <ul className="body-s mt-4 max-h-80 list-none space-y-3 overflow-y-auto p-0">
        {segmentErrors.map((error) => (
          <li
            className="border-t border-black-tint-90 pt-3"
            key={`${error.activity_title}-${error.segment_title}-${error.message}`}
          >
            <p className="bold text-black-tint-10">
              {error.activity_title} › {error.segment_title}
            </p>
            <p className="mt-1 text-black-tint-30">{error.message}</p>
          </li>
        ))}
      </ul>
    </Dialog>
  );
};
